import { render, staticRenderFns } from "./FileCounter.vue?vue&type=template&id=dd9e2432&"
import script from "./FileCounter.vue?vue&type=script&lang=js&"
export * from "./FileCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports